// VerifyAccount.jsx

import React, { useState, useEffect } from "react";

import { Form, Alert, Button, Container, Card } from "react-bootstrap";
import { Auth } from "aws-amplify";

import { useLocation } from "react-router-dom";
import { useNavigate } from 'react-router-dom';

import { AppContext } from "../context/appContext"; // adjust path if needed
import { useContext } from "react";



export default function VerifyAccount() {
  const location = useLocation();
  const [verificationCode, setVerificationCode] = useState("");
  const [username, setUsername] = useState(location.state?.email || "");
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const navigate = useNavigate();
  console.log("using appcontext to get global loading");
  const { setGlobalLoading } = useContext(AppContext);
  console.log("globalloading was reset in verify account");

  useEffect(() => {
    // ❌ Don't clear loading instantly — simulate real loading or wait for data
    const timeout = setTimeout(() => {
      console.log("verify account - setting global loading to false");
      setGlobalLoading(false);
    }, 100); // 👈 You can adjust this as needed

    return () => clearTimeout(timeout);
  }, [setGlobalLoading]);


  useEffect(() => {
    if (location.state?.email) {
      setUsername(location.state.email);
    }
  }, [location.state]);



  const handleVerify = async (e) => {
    e.preventDefault();
    const formattedUsername = username.toLowerCase(); // Ensure lowercase before verification

    try {
      await Auth.confirmSignUp(formattedUsername, verificationCode);
      setSuccess('Verification successful, redirecting you to the login page now.');
      setError('');
      setTimeout(() => {
       //window.location.href = '/';
       navigate('/login');  // ← This is the React way to reroute
      }, 3000);
    } catch (error) {
      console.error('Verification error:', error);
      setError('Verification code entered incorrectly. Please try again.');
      setSuccess('');
    }
  };

  return (
    <Container className="d-flex justify-content-center" style={{ paddingTop: "80px", paddingBottom: "40px" }}>
    <Card className="p-4 shadow-sm" style={{ width: "100%", maxWidth: "480px", fontFamily: "'DM Sans', sans-serif" }}>
      <h3 className="text-center mb-3" style={{ color: "#FEA2C2", fontWeight: 700 }}>Verify Your Account</h3>

      <Form onSubmit={handleVerify}>
        
        {error && <Alert variant="danger" className="text-center">{error}</Alert>}
        {success && <Alert variant="success" className="text-center">{success}</Alert>}

        {!location.state?.email && (
            <Form.Group className="mb-3">
              <Form.Label>Email Address</Form.Label>
              <Form.Control
                type="email"
                placeholder="you@example.com"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
              />
            </Form.Group>
          )}

        <Form.Group className="mb-3">
          <Form.Label>Verification Code</Form.Label>
          <Form.Control
            type="text"
            placeholder="123456"
            value={verificationCode}
            onChange={(e) => setVerificationCode(e.target.value)}
            required
          />
        </Form.Group>

        <Button
          type="submit"
          className="w-100"
          style={{
            backgroundColor: "#FEA2C2",
            border: "none",
            fontWeight: "bold",
            padding: "10px",
            fontSize: "1.1rem",
            borderRadius: "8px",
          }}
        >
          Verify
        </Button>
      </Form>
    </Card>
  </Container>
  );
}
